export function isMaintenanceModeEnabled(value) {
  return String(value ?? "").trim().toLowerCase() === "true";
}

export const MAINTENANCE_MODE_ENABLED = isMaintenanceModeEnabled(
  process.env.REACT_APP_MAINTENANCE_MODE,
);
